import TabElement from '../VTabsV2/TabElement';

class TabElementGrouped extends TabElement {
	public group:      string;
	public groupLabel: string;

	static from(
		id:         string,
		name:       string,
		count:      number | null = null,
		hidden:     boolean       = false,
		group:      string        = '',
		groupLabel: string        = '',
	): TabElementGrouped {
		const tab        = super.from(id, name, count, hidden) as TabElementGrouped;
		tab.group        = group;
		tab.groupLabel   = groupLabel;
		return tab;
	}

	/**
	 * Имя для отображения таба
	 */
	public get displayName(): string {
		return this.name;
	}

	public get displayGroupLabel(): string {
		return this.groupLabel;
	}
}

export default TabElementGrouped;
